import React from "react";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import About from "../components/About";
import BusinessPortfolio from "../components/BusinessPortfolio";
import Philosophy from "../components/Philosophy";
import ProjectsShowcase from "../components/ProjectsShowcase";
import LeadershipImpact from "../components/LeadershipImpact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <BusinessPortfolio />
      <Philosophy />
      <ProjectsShowcase />
      <LeadershipImpact />
      <Footer />
    </>
  );
}

